/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import type {
  BadRequestResponse,
  ConnectedSupplierCatalogsDTO,
  DeleteSuccessDTO,
  ForbiddenResponse,
  GetPlatformCatalogsParams,
  InternalServerErrorResponse,
  NotFoundResponse,
  PaginatedPlatformCatalogListItemsDTO,
  PlatformCatalogCreateDTO,
  PlatformCatalogDTO,
  PlatformCatalogSynchronisationCheckDTO,
  PlatformCatalogUpdateDTO,
  UnauthorizedResponse,
} from "../../model";
import { customFetchInstance } from "../../../custom-fetch-instance";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Retrieval of all platform catalogs
 * @summary Returns all platform catalogs
 */
export type getPlatformCatalogsResponse = {
  data: PaginatedPlatformCatalogListItemsDTO;
  status: number;
};

export const getGetPlatformCatalogsUrl = (
  supplierId: string,
  params?: GetPlatformCatalogsParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs?${normalizedParams.toString()}`
    : `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs`;
};

export const getPlatformCatalogs = async (
  supplierId: string,
  params?: GetPlatformCatalogsParams,
  options?: RequestInit
): Promise<getPlatformCatalogsResponse> => {
  return customFetchInstance<Promise<getPlatformCatalogsResponse>>(
    getGetPlatformCatalogsUrl(supplierId, params),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetPlatformCatalogsQueryKey = (
  supplierId: string,
  params?: GetPlatformCatalogsParams
) => {
  return [
    `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPlatformCatalogsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformCatalogs>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetPlatformCatalogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPlatformCatalogsQueryKey(supplierId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformCatalogs>>
  > = ({ signal }) =>
    getPlatformCatalogs(supplierId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!supplierId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformCatalogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformCatalogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformCatalogs>>
>;
export type GetPlatformCatalogsQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetPlatformCatalogs<
  TData = Awaited<ReturnType<typeof getPlatformCatalogs>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params: undefined | GetPlatformCatalogsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformCatalogs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogs<
  TData = Awaited<ReturnType<typeof getPlatformCatalogs>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetPlatformCatalogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformCatalogs>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogs<
  TData = Awaited<ReturnType<typeof getPlatformCatalogs>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetPlatformCatalogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns all platform catalogs
 */

export function useGetPlatformCatalogs<
  TData = Awaited<ReturnType<typeof getPlatformCatalogs>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetPlatformCatalogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlatformCatalogsQueryOptions(
    supplierId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPlatformCatalogsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformCatalogs>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetPlatformCatalogsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPlatformCatalogsQueryKey(supplierId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformCatalogs>>
  > = ({ signal }) =>
    getPlatformCatalogs(supplierId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!supplierId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPlatformCatalogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformCatalogsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformCatalogs>>
>;
export type GetPlatformCatalogsSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetPlatformCatalogsSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogs>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params: undefined | GetPlatformCatalogsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogsSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogs>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetPlatformCatalogsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogsSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogs>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetPlatformCatalogsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns all platform catalogs
 */

export function useGetPlatformCatalogsSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogs>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  params?: GetPlatformCatalogsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlatformCatalogsSuspenseQueryOptions(
    supplierId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Allows the creation of a new platform catalog container.
 * @summary Creates a new platform catalog container
 */
export type createPlatformCatalogResponse = {
  data: PlatformCatalogDTO;
  status: number;
};

export const getCreatePlatformCatalogUrl = (supplierId: string) => {
  return `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs`;
};

export const createPlatformCatalog = async (
  supplierId: string,
  platformCatalogCreateDTO: PlatformCatalogCreateDTO,
  options?: RequestInit
): Promise<createPlatformCatalogResponse> => {
  return customFetchInstance<Promise<createPlatformCatalogResponse>>(
    getCreatePlatformCatalogUrl(supplierId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(platformCatalogCreateDTO),
    }
  );
};

export const getCreatePlatformCatalogMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlatformCatalog>>,
    TError,
    { supplierId: string; data: PlatformCatalogCreateDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPlatformCatalog>>,
  TError,
  { supplierId: string; data: PlatformCatalogCreateDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPlatformCatalog>>,
    { supplierId: string; data: PlatformCatalogCreateDTO }
  > = (props) => {
    const { supplierId, data } = props ?? {};

    return createPlatformCatalog(supplierId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePlatformCatalogMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPlatformCatalog>>
>;
export type CreatePlatformCatalogMutationBody = PlatformCatalogCreateDTO;
export type CreatePlatformCatalogMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Creates a new platform catalog container
 */
export const useCreatePlatformCatalog = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPlatformCatalog>>,
    TError,
    { supplierId: string; data: PlatformCatalogCreateDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPlatformCatalog>>,
  TError,
  { supplierId: string; data: PlatformCatalogCreateDTO },
  TContext
> => {
  const mutationOptions = getCreatePlatformCatalogMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Returns a list of catalogs that need further actions. This can be either a needed synchronisation or adjustment of rules.
 * @summary Returns a list of catalogs that need further actions.
 */
export type getPlatformCatalogSynchronisationCheckResponse = {
  data: PlatformCatalogSynchronisationCheckDTO[];
  status: number;
};

export const getGetPlatformCatalogSynchronisationCheckUrl = (
  supplierId: string
) => {
  return `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/synchronisation-check`;
};

export const getPlatformCatalogSynchronisationCheck = async (
  supplierId: string,
  options?: RequestInit
): Promise<getPlatformCatalogSynchronisationCheckResponse> => {
  return customFetchInstance<
    Promise<getPlatformCatalogSynchronisationCheckResponse>
  >(getGetPlatformCatalogSynchronisationCheckUrl(supplierId), {
    ...options,
    method: "GET",
  });
};

export const getGetPlatformCatalogSynchronisationCheckQueryKey = (
  supplierId: string
) => {
  return [
    `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/synchronisation-check`,
  ] as const;
};

export const getGetPlatformCatalogSynchronisationCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPlatformCatalogSynchronisationCheckQueryKey(supplierId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>
  > = ({ signal }) =>
    getPlatformCatalogSynchronisationCheck(supplierId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!supplierId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformCatalogSynchronisationCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>
>;
export type GetPlatformCatalogSynchronisationCheckQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetPlatformCatalogSynchronisationCheck<
  TData = Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogSynchronisationCheck<
  TData = Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogSynchronisationCheck<
  TData = Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a list of catalogs that need further actions.
 */

export function useGetPlatformCatalogSynchronisationCheck<
  TData = Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlatformCatalogSynchronisationCheckQueryOptions(
    supplierId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPlatformCatalogSynchronisationCheckSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPlatformCatalogSynchronisationCheckQueryKey(supplierId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>
  > = ({ signal }) =>
    getPlatformCatalogSynchronisationCheck(supplierId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!supplierId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformCatalogSynchronisationCheckSuspenseQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>
  >;
export type GetPlatformCatalogSynchronisationCheckSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetPlatformCatalogSynchronisationCheckSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogSynchronisationCheckSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogSynchronisationCheckSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a list of catalogs that need further actions.
 */

export function useGetPlatformCatalogSynchronisationCheckSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogSynchronisationCheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetPlatformCatalogSynchronisationCheckSuspenseQueryOptions(
      supplierId,
      options
    );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieval of a specific platform catalog container
 * @summary Returns a specific platform catalog container
 */
export type getPlatformCatalogByIdResponse = {
  data: PlatformCatalogDTO;
  status: number;
};

export const getGetPlatformCatalogByIdUrl = (
  supplierId: string,
  platformCatalogId: string
) => {
  return `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/${platformCatalogId}`;
};

export const getPlatformCatalogById = async (
  supplierId: string,
  platformCatalogId: string,
  options?: RequestInit
): Promise<getPlatformCatalogByIdResponse> => {
  return customFetchInstance<Promise<getPlatformCatalogByIdResponse>>(
    getGetPlatformCatalogByIdUrl(supplierId, platformCatalogId),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetPlatformCatalogByIdQueryKey = (
  supplierId: string,
  platformCatalogId: string
) => {
  return [
    `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/${platformCatalogId}`,
  ] as const;
};

export const getGetPlatformCatalogByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformCatalogById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPlatformCatalogByIdQueryKey(supplierId, platformCatalogId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformCatalogById>>
  > = ({ signal }) =>
    getPlatformCatalogById(supplierId, platformCatalogId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(supplierId && platformCatalogId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformCatalogById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformCatalogByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformCatalogById>>
>;
export type GetPlatformCatalogByIdQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetPlatformCatalogById<
  TData = Awaited<ReturnType<typeof getPlatformCatalogById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformCatalogById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogById<
  TData = Awaited<ReturnType<typeof getPlatformCatalogById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformCatalogById>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogById<
  TData = Awaited<ReturnType<typeof getPlatformCatalogById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a specific platform catalog container
 */

export function useGetPlatformCatalogById<
  TData = Awaited<ReturnType<typeof getPlatformCatalogById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlatformCatalogByIdQueryOptions(
    supplierId,
    platformCatalogId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPlatformCatalogByIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformCatalogById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPlatformCatalogByIdQueryKey(supplierId, platformCatalogId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPlatformCatalogById>>
  > = ({ signal }) =>
    getPlatformCatalogById(supplierId, platformCatalogId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(supplierId && platformCatalogId),
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPlatformCatalogById>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPlatformCatalogByIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformCatalogById>>
>;
export type GetPlatformCatalogByIdSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetPlatformCatalogByIdSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogByIdSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetPlatformCatalogByIdSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a specific platform catalog container
 */

export function useGetPlatformCatalogByIdSuspense<
  TData = Awaited<ReturnType<typeof getPlatformCatalogById>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  supplierId: string,
  platformCatalogId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPlatformCatalogById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPlatformCatalogByIdSuspenseQueryOptions(
    supplierId,
    platformCatalogId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Allows to update of a platform catalog container.
 * @summary Updates an existing platform catalog container
 */
export type updatePlatformCatalogResponse = {
  data: PlatformCatalogDTO;
  status: number;
};

export const getUpdatePlatformCatalogUrl = (
  supplierId: string,
  platformCatalogId: string
) => {
  return `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/${platformCatalogId}`;
};

export const updatePlatformCatalog = async (
  supplierId: string,
  platformCatalogId: string,
  platformCatalogUpdateDTO: PlatformCatalogUpdateDTO,
  options?: RequestInit
): Promise<updatePlatformCatalogResponse> => {
  return customFetchInstance<Promise<updatePlatformCatalogResponse>>(
    getUpdatePlatformCatalogUrl(supplierId, platformCatalogId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(platformCatalogUpdateDTO),
    }
  );
};

export const getUpdatePlatformCatalogMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlatformCatalog>>,
    TError,
    {
      supplierId: string;
      platformCatalogId: string;
      data: PlatformCatalogUpdateDTO;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePlatformCatalog>>,
  TError,
  {
    supplierId: string;
    platformCatalogId: string;
    data: PlatformCatalogUpdateDTO;
  },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePlatformCatalog>>,
    {
      supplierId: string;
      platformCatalogId: string;
      data: PlatformCatalogUpdateDTO;
    }
  > = (props) => {
    const { supplierId, platformCatalogId, data } = props ?? {};

    return updatePlatformCatalog(
      supplierId,
      platformCatalogId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePlatformCatalogMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePlatformCatalog>>
>;
export type UpdatePlatformCatalogMutationBody = PlatformCatalogUpdateDTO;
export type UpdatePlatformCatalogMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Updates an existing platform catalog container
 */
export const useUpdatePlatformCatalog = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePlatformCatalog>>,
    TError,
    {
      supplierId: string;
      platformCatalogId: string;
      data: PlatformCatalogUpdateDTO;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePlatformCatalog>>,
  TError,
  {
    supplierId: string;
    platformCatalogId: string;
    data: PlatformCatalogUpdateDTO;
  },
  TContext
> => {
  const mutationOptions = getUpdatePlatformCatalogMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Allows the deletion of a platform catalog container.
 * @summary Deletes a specific platform catalog container
 */
export type deletePlatformCatalogByIdResponse = {
  data: DeleteSuccessDTO;
  status: number;
};

export const getDeletePlatformCatalogByIdUrl = (
  supplierId: string,
  platformCatalogId: string
) => {
  return `http://localhost:8080/platform/v1/suppliers/${supplierId}/platform-catalogs/${platformCatalogId}`;
};

export const deletePlatformCatalogById = async (
  supplierId: string,
  platformCatalogId: string,
  options?: RequestInit
): Promise<deletePlatformCatalogByIdResponse> => {
  return customFetchInstance<Promise<deletePlatformCatalogByIdResponse>>(
    getDeletePlatformCatalogByIdUrl(supplierId, platformCatalogId),
    {
      ...options,
      method: "DELETE",
    }
  );
};

export const getDeletePlatformCatalogByIdMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlatformCatalogById>>,
    TError,
    { supplierId: string; platformCatalogId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePlatformCatalogById>>,
  TError,
  { supplierId: string; platformCatalogId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePlatformCatalogById>>,
    { supplierId: string; platformCatalogId: string }
  > = (props) => {
    const { supplierId, platformCatalogId } = props ?? {};

    return deletePlatformCatalogById(
      supplierId,
      platformCatalogId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePlatformCatalogByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePlatformCatalogById>>
>;

export type DeletePlatformCatalogByIdMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Deletes a specific platform catalog container
 */
export const useDeletePlatformCatalogById = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePlatformCatalogById>>,
    TError,
    { supplierId: string; platformCatalogId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePlatformCatalogById>>,
  TError,
  { supplierId: string; platformCatalogId: string },
  TContext
> => {
  const mutationOptions = getDeletePlatformCatalogByIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Returns a list of
 * @summary Get a list of available catalogs of an audiologist's connected suppliers
 */
export type getSupplierCatalogsOfAudiologistResponse = {
  data: ConnectedSupplierCatalogsDTO[];
  status: number;
};

export const getGetSupplierCatalogsOfAudiologistUrl = (
  audiologistId: string
) => {
  return `http://localhost:8080/platform/v1/audiologists/${audiologistId}/catalogs`;
};

export const getSupplierCatalogsOfAudiologist = async (
  audiologistId: string,
  options?: RequestInit
): Promise<getSupplierCatalogsOfAudiologistResponse> => {
  return customFetchInstance<Promise<getSupplierCatalogsOfAudiologistResponse>>(
    getGetSupplierCatalogsOfAudiologistUrl(audiologistId),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetSupplierCatalogsOfAudiologistQueryKey = (
  audiologistId: string
) => {
  return [
    `http://localhost:8080/platform/v1/audiologists/${audiologistId}/catalogs`,
  ] as const;
};

export const getGetSupplierCatalogsOfAudiologistQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSupplierCatalogsOfAudiologistQueryKey(audiologistId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>
  > = ({ signal }) =>
    getSupplierCatalogsOfAudiologist(audiologistId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!audiologistId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSupplierCatalogsOfAudiologistQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>
>;
export type GetSupplierCatalogsOfAudiologistQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetSupplierCatalogsOfAudiologist<
  TData = Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetSupplierCatalogsOfAudiologist<
  TData = Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetSupplierCatalogsOfAudiologist<
  TData = Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get a list of available catalogs of an audiologist's connected suppliers
 */

export function useGetSupplierCatalogsOfAudiologist<
  TData = Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSupplierCatalogsOfAudiologistQueryOptions(
    audiologistId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSupplierCatalogsOfAudiologistSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSupplierCatalogsOfAudiologistQueryKey(audiologistId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>
  > = ({ signal }) =>
    getSupplierCatalogsOfAudiologist(audiologistId, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!audiologistId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSupplierCatalogsOfAudiologistSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>
>;
export type GetSupplierCatalogsOfAudiologistSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetSupplierCatalogsOfAudiologistSuspense<
  TData = Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetSupplierCatalogsOfAudiologistSuspense<
  TData = Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetSupplierCatalogsOfAudiologistSuspense<
  TData = Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get a list of available catalogs of an audiologist's connected suppliers
 */

export function useGetSupplierCatalogsOfAudiologistSuspense<
  TData = Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSupplierCatalogsOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSupplierCatalogsOfAudiologistSuspenseQueryOptions(
    audiologistId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
